import SysValidations from "config/lang/SysValidations";

const Validations = {
  ...SysValidations,
  needTasks: "Se requiere al menos 1 tarea",
};

export default Validations;
